import React from 'react';
import StyKeyIndicatorsTitle from 'routes/HumanResourcesModule/components/ui/StyKeyIndicatorsTitle';
import { Grid, Paper, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { HrGridPaperElement } from './types';

const StyPaper = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    textAlign: 'left',
    padding: '1rem',
    height: '100%',
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
}));

const AmountLoader = () => (
    <Skeleton variant="rectangular" width={100} height={20} />
);

type Props = {
    elements: HrGridPaperElement[];
};

/**
 * A styled Paper component that is typically used in a Grid component.
 * It displays children elements in a column and has a light blue background.
 * The component is intended to be used in a Human Resources module.
 * @param {{ children: ReactNode }} props
 * @returns {ReactElement}
 */
export const HrGridPaper = ({ elements = [] }: Props): React.ReactElement => {
    return (
        <Grid
            container
            spacing={2}
            sx={{
                flexGrow: '1',
            }}
        >
            {elements.map((element, i) => (
                <Grid item xs={12} key={i}>
                    <StyPaper>
                        <StyKeyIndicatorsTitle sx={{ paddingBottom: '0.5rem' }}>
                            {element.title}
                            {element.tooltip && element.tooltip}
                        </StyKeyIndicatorsTitle>
                        {element.isLoading ? (
                            <AmountLoader />
                        ) : (
                            element.children
                        )}
                    </StyPaper>
                </Grid>
            ))}
        </Grid>
    );
};
